<section class="about-us-section">
  <div class="about-us-container">
    <div class="about-us-media">
      @if (mainImageSrc) {
        @if (isVideo(mainImageSrc)) {
          <video [src]="mainImageSrc" autoplay loop muted playsinline class="about-us-video"></video>
        } @else {
          <img [src]="mainImageSrc" alt="About us" class="about-us-video" />
        }
      } @else if (videoSrc) {
        <video [src]="videoSrc" autoplay loop muted playsinline class="about-us-video"></video>
      }
      @if (overlayImage) {
        <div class="about-us-image">
          @if (isVideo(overlayImage)) {
            <video [src]="overlayImage" autoplay loop muted playsinline class="overlay-img"></video>
          } @else {
            <img [src]="overlayImage" alt="About us" class="overlay-img" />
          }
        </div>
      }
    </div>
    <div class="about-us-content-container">
      <div class="about-us-content">
        @if (eyebrowText) {
          <div class="eyebrow-heading">
            <!-- @if (eyebrowIcon) {
              <mat-icon
                [svgIcon]="eyebrowIcon"
                class="eyebrow-icon"
                [style.color]="eyebrowIconColor"
                [attr.aria-label]="eyebrowText">
              </mat-icon>
            } -->
            <span class="eyebrow-text">{{ eyebrowText | translateLang | slice:0:47 }}</span>
          </div>
        }
        <h2 class="about-headline">{{ headline | translateLang }}</h2>
        <p class="subtext">{{ subtext | translateLang }}</p>
        <app-button
          [label]="buttonlabel | translateLang "
          variant="yellow"
          (clicked)="handleButtonClick()">
        </app-button>
      </div>
    </div>
  </div>
</section>
